// Accesos recientes: persiste las últimas SECCIONES (rutas) visitadas en
// localStorage para mostrarlas como acceso rápido en Home. Guarda SOLO paths
// de secciones del catálogo (sin PII): no registros individuales.

const STORAGE_KEY = "mediline.recentSections";
const MAX_RECENT = 6;

// Lógica pura: dada la lista previa, devuelve la nueva con `path` al frente,
// sin duplicados y recortada al tope. No toca localStorage (testeable directo).
export const computeRecentList = (prev, path, max = MAX_RECENT) =>
  [path, ...prev.filter((p) => p !== path)].slice(0, max);

export const getRecentSectionPaths = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.filter((p) => typeof p === "string") : [];
  } catch {
    return [];
  }
};

export const recordRecentSection = (path) => {
  const next = computeRecentList(getRecentSectionPaths(), path);
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    // localStorage no disponible (modo privado, cuota) → ignorar.
  }
  return next;
};

export const clearRecentSections = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignorar
  }
};
